import * as Redux from 'redux'
import * as Types from './types'
import * as Utils from './utils'

export interface ChangePageAction extends Redux.Action { pageChange: Types.PageChange }
export type ChangePageFunction = (pageChange: Types.PageChange) => ChangePageAction
export const changePage = (prefix: string): ChangePageFunction => (pageChange: Types.PageChange) =>
  ({type: Utils.changePageConstant(prefix), pageChange: {skip: pageChange.skip, take: pageChange.take, pageNumber: 0}})

export type InitializePageFunction = () => Redux.Action
export const initializePage = (prefix: string): InitializePageFunction => () =>
  ({type: Utils.initializePageConstant(prefix)})

export interface PaginationAction extends Redux.Action {
  pageNumber: Types.PageNumber,
  prefix: string
}

export type GoToPageAction = (pageNumber: Types.PageNumber, prefix: string) => PaginationAction
export const goToPage: GoToPageAction = (pageNumber: Types.PageNumber, prefix: string) => ({
  pageNumber,
  prefix,
  type: Utils.goToPageConstant(prefix),
})



// WEBPACK FOOTER //
// ./src/components/pager/actions.ts